export default __webpack_public_path__ + "static/media/assistant.17a42264.png";